import { render, staticRenderFns } from "./Ylfw.vue?vue&type=template&id=3ca74cbd&"
import script from "./Ylfw.vue?vue&type=script&lang=ts&"
export * from "./Ylfw.vue?vue&type=script&lang=ts&"
import style0 from "./Ylfw.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports